import { RemoveStoryMeta, RemoveStoryPayload } from 'types/store/RemoveStory';
import { createAsyncReducer } from 'utils/Redux';

import { removeStoryActions } from '../actions';

export default createAsyncReducer<RemoveStoryMeta, RemoveStoryPayload>(removeStoryActions);
